<template>
  <div class="header-top">
    <div class="site-header site-wrapper">
      <div class="site-header__brand">
        <a href="javascript:;" class="logo"><img :src="$store.state.pageInfo && getUrl($store.state.pageInfo.systemLogo)" alt="" /></a>
        <span style="font-size: 20px;padding-left: 10px;border-left: 2px solid #fafafa;margin-left: 13px;">{{headerTitle}}</span>
      </div>
      <div class="site-header__nav">
      </div>
      <div class="site-header__lors">
        <span @click="$router.push({ name: 'home' })">返回首页</span>
      </div>
    </div>
  </div>
</template>

<script>
import { previewUrl } from "@/utils";
export default {
  props:{
    headerTitle:{
      type:String,
      default:""
    }
  },
  methods:{
    getUrl(url){
      return previewUrl(url);
    }
  }
};
</script>

<style lang="scss" scoped>
/**header 高 */
$--header-height: 72px;
.header-top {
  background: #fff;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.04);
  .site-header {
    display: flex;
    height: $--header-height;
    line-height: $--header-height;
    &__brand {
      .logo {
        img {
          height: 48px!important;
        }
      }
    }
    &__nav {
      flex: 1;
      text-align: center;
      ul > li {
        display: inline-block;
        &.active a {
          background: #1460ae;
          color: #fff;
        }
        a {
          display: block;
          font-size: 16px;
          padding: 0 24px;
          text-decoration: none;
        }
      }
    }
    &__lors {
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
